import React, { useMemo } from 'react'
import { map, uniq, sortBy, toString } from 'lodash'

import Filters from 'Features/Filters'
import { arrayToOptions } from 'Utilities/selectOptions'

const getFromDevices = (devices, field) => sortBy(uniq(map(devices, field)))
const capitalizeSplit = (string) => {
  if (string === 'N/A') { return string }

  return toString(string).split(/(?=[A-Z])/).join(' ')
}

const defaultFilters = {
  locations: 'All',
  clusters: 'All',
  dataProtection: 'All',
  monitoring: 'All',
  antiVirus: 'All',
  patching: 'All',
  calligoManagement: 'All',
  deviceTypes: 'All',
  powerState: 'All',
  encryption: 'All',
  passwordPolicyStrength: 'All',
  firewall: 'All',
  cve: 'All',
}

const DeviceIntegrationReportFilters = ({ filters = {}, changeFilters, devices }) => {
  const antivirusStatuses = useMemo(() => arrayToOptions(getFromDevices(devices, 'antivirus_status'), capitalizeSplit))
  const patchingStatuses = useMemo(() => arrayToOptions(getFromDevices(devices, 'patching_status'), capitalizeSplit))
  const cveOptions = useMemo(() => [
    { value: "critical", label: 'Critical' },
    { value: "high", label: 'High' },
    { value: "medium", label: 'Medium' },
    { value: "low", label: 'Low' },
    { value: "none", label: 'None' },
  ])

  const demoOptions = useMemo(() => [
    { value: 0, label: 'Compliant' },
    { value: 1, label: 'Not Fully Compliant' },
    { value: 2, label: 'Not Compliant' },
  ])

  const clusters = useMemo(() => arrayToOptions(getFromDevices(devices, 'cluster')))
  const locations = useMemo(() => arrayToOptions(getFromDevices(devices, 'location')))
  const deviceTypes = useMemo(() => arrayToOptions(getFromDevices(devices, 'device_type')))
  const powerState = useMemo(() => arrayToOptions(['All', ...getFromDevices(devices, 'power_state')]))
  const calligoManagement = useMemo(() => [
    { value: "true", label: 'Calligo Management Device' },
    { value: "false", label: 'Customer' }
  ])

  const integrationStatuses = useMemo(() => [
    { value: "true", label: 'Integrated' },
    { value: "false", label: 'Not integrated' },
    { value: "n/a", label: 'N/A' },
  ])

  return (
    <Filters {...{ filters, onChange: changeFilters, shareable: true }}>
      <div className="col">
        <div className='row mb-3'>
          <Filters.Select {...{ filterName: 'deviceTypes', label: 'Device Type', options: deviceTypes }} />
          <Filters.Select {...{ filterName: 'powerState', label: 'Power State', options: powerState, isMulti: false }} />
          <Filters.Select {...{ filterName: 'antiVirus', label: 'Anti Virus', options: antivirusStatuses }} />
          <Filters.Select {...{ filterName: 'patching', label: 'Patching', options: patchingStatuses }} />
        </div>

        <div className='row'>
          <Filters.Select {...{ filterName: 'encryption', label: 'Disk Encryption', options: demoOptions, sortOptions: false }} />
          <Filters.Select {...{ filterName: 'passwordPolicyStrength', label: 'Password Policy Strength', options: demoOptions, sortOptions: false }} />
          <Filters.Select {...{ filterName: 'firewall', label: 'Firewall', options: demoOptions, sortOptions: false }} />
          <Filters.Select {...{ filterName: 'cve', label: 'CVE', options: cveOptions, sortOptions: false }} />
        </div>
      </div>
    </Filters>
  )
}

export { DeviceIntegrationReportFilters as Filters, defaultFilters }
